import { FunctionalComponent, h } from '@stencil/core';
import { FundData } from '../../_interfaces/fund-card/fund-data';
import {
	setEsgDataPoints,
	formatTooltipDate,
	setDisplayStyle,
	getEsgBasedOnHoldingsDate,
} from './_helpers';

interface EsgDataPointsProps {
	domicileType: string;
	data: FundData;
	esgVisibility: string;
	Tooltip: string;
	i?: number;
}

export const EsgDataPoints = ({
	domicileType,
	data,
	esgVisibility,
	Tooltip,
	i = 0,
}): FunctionalComponent<EsgDataPointsProps> => {
	const {
		esgAnalytics,
		keyfundfacts,
		domicile,
		activeDataPoints,
		contentTranslations,
	} = data;
	const { labelDataAsOf, labelHoldingsAsOf } = contentTranslations;

	const attributes = setEsgDataPoints(
		domicileType,
		domicile,
		esgAnalytics,
		keyfundfacts
	);

	const basedOnHoldingsDate = getEsgBasedOnHoldingsDate(esgAnalytics);

	return (
		<div
			class={`ds-data-points ds-data-points-${i}`}
			style={setDisplayStyle(activeDataPoints, esgVisibility)}
		>
			{attributes.map((fundDataElement, i) => {
				if (fundDataElement.flag) {
					return (
						<div
							class="ds-body-s ds-esg-data-point"
							key={fundDataElement.label + i}
						>
							<div class="ds-esg-datapoint-left">
								{`${fundDataElement.label} `}
								{fundDataElement.tooltip ? (
									<Tooltip
										content={`${fundDataElement.tooltip}${formatTooltipDate(
											labelDataAsOf,
											fundDataElement.asOf,
											false
										)}${formatTooltipDate(
											labelHoldingsAsOf,
											basedOnHoldingsDate,
											fundDataElement.sfdr
										)}`}
									></Tooltip>
								) : null}
							</div>
							<div class="ds-esg-datapoint-right">
								{fundDataElement.prefix} {fundDataElement.value}
							</div>
						</div>
					);
				}
			})}
		</div>
	);
};
